<div class="main-container">
  <i class="fas fa-check-circle"></i>
  <span>
    {{ 'PAYMENT.ALERTS.PERFORMED_SUCCESSFULLY' | translate }}
  </span>
</div>
